import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Facebook, Youtube, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-black text-white border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-2 mb-4 cursor-pointer" onClick={() => navigate('/')}>
              <img 
                src="/assets/ace_logo_horizontal.webp" 
                alt="ACE Logo" 
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="text-sm text-gray-400 mb-4">
              Atlanta luxury car service and auto lifestyle consultancy. Concierge-driven transportation and vehicle consulting services.
            </p>
            <div className="flex space-x-3">
              <a href="https://facebook.com/AutoConciergeEnt" target="_blank" rel="noopener noreferrer" className="h-8 w-8 rounded-full bg-gray-800 hover:bg-red-600 flex items-center justify-center transition-colors" data-testid="footer-facebook">
                <Facebook className="h-4 w-4" />
              </a>
              <a href="https://youtube.com/@YourAutoConcierge/videos" target="_blank" rel="noopener noreferrer" className="h-8 w-8 rounded-full bg-gray-800 hover:bg-red-600 flex items-center justify-center transition-colors" data-testid="footer-youtube">
                <Youtube className="h-4 w-4" />
              </a>
              <a href="https://linkedin.com/in/jdlawrenceace" target="_blank" rel="noopener noreferrer" className="h-8 w-8 rounded-full bg-gray-800 hover:bg-red-600 flex items-center justify-center transition-colors" data-testid="footer-linkedin">
                <Linkedin className="h-4 w-4" />
              </a>
              <a href="mailto:info@yourautoconcierge.com" className="h-8 w-8 rounded-full bg-gray-800 hover:bg-red-600 flex items-center justify-center transition-colors" data-testid="footer-email">
                <Mail className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Services Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Services</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <button onClick={() => navigate('/driven')} className="hover:text-red-500 transition-colors" data-testid="footer-driven-link">
                  Concierge-Driven Car Service
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/driving')} className="hover:text-red-500 transition-colors" data-testid="footer-driving-link">
                  Consultations & Vehicle Services
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/corporate')} className="hover:text-red-500 transition-colors" data-testid="footer-corporate-link">
                  Corporate Services
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/fleet-gallery')} className="hover:text-red-500 transition-colors" data-testid="footer-fleet-link">
                  Fleet Gallery
                </button>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <button onClick={() => navigate('/membership')} className="hover:text-red-500 transition-colors" data-testid="footer-membership-link">
                  ACE Memberships
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/consultation')} className="hover:text-red-500 transition-colors" data-testid="footer-consultation-link">
                  Free Consultation
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/contact')} className="hover:text-red-500 transition-colors" data-testid="footer-contact-link">
                  Contact Us
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/portal/login')} className="hover:text-red-500 transition-colors" data-testid="footer-portal-link">
                  Client Portal
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact</h3>
            <ul className="space-y-3 text-sm text-gray-400">
              <li className="flex items-start">
                <Phone className="h-4 w-4 mr-2 mt-0.5 flex-shrink-0" />
                <a href="tel:6788463009" className="hover:text-red-500 transition-colors" data-testid="footer-phone">
                  (678) 846-3009
                </a>
              </li>
              <li className="flex items-start">
                <Mail className="h-4 w-4 mr-2 mt-0.5 flex-shrink-0" />
                <a href="mailto:JD@yourautoconcierge.com" className="hover:text-red-500 transition-colors" data-testid="footer-email-link">
                  JD@yourautoconcierge.com
                </a>
              </li>
              <li className="flex items-start">
                <MapPin className="h-4 w-4 mr-2 mt-0.5 flex-shrink-0" />
                <span>1954 Airport Rd Suite 500<br />Chamblee, GA 30341</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-400 mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} All Rights Reserved | Auto Concierge Enterprises
          </p>
          <div className="flex space-x-6 text-sm text-gray-400">
            <button onClick={() => navigate('/contact')} className="hover:text-red-500 transition-colors">Privacy Policy</button>
            <button onClick={() => navigate('/contact')} className="hover:text-red-500 transition-colors">Terms of Service</button>
            <button onClick={() => navigate('/admin/login')} className="text-gray-700 hover:text-gray-400 transition-colors" data-testid="footer-admin-login">Team Login</button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
